import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import "./styles.scss";
const columns = [
  {
    title: "Resim",
    dataIndex: "bannerImage",
    key: "bannerImage",
    width: "10%",
    render: (text, render) => (
      <img
        alt={"banners"}
        style={{ width: "100%" }}
        src={render.bannerImage}
      ></img>
    ),
  },
  {
    title: "Ürün",
    dataIndex: "name",
    key: "name",
    render: (text, render) => (
      <Link to={`/allproducts/product/${render._id}`}>{text}</Link>
    ),
  },
  {
    title: "Stok Miktarı",
    dataIndex: "stockAmount",
    key: "stock",
    sorter: (a, b) => parseFloat(a.stockAmount) - parseFloat(b.stockAmount),
    render: (text, render) => <p style={{ fontSize: "15px" }}> {text} Adet </p>,
  },
  {
    title: "İndirim Oranı",
    dataIndex: "discountRate",
    key: "discount",
    sorter: (a, b) => parseFloat(a.discountRate) - parseFloat(b.discountRate),
    render: (text, render) => <p style={{ fontSize: "15px" }}>% {text} </p>,
  },
  {
    title: "Kategori",
    dataIndex: "category",
    key: "category",
    filters: [
      {
        text: "Siseler ve Kavanozlar",
        value: "siseleme",
      },
      {
        text: "Demleme Yardimcilari",
        value: "yardimci",
      },
      {
        text: "Kitler",
        value: "kit",
      },
      {
        text: "Kombucha Icecek",
        value: "icecek",
      },
      {
        text: "Caylar",
        value: "cay",
      },
      {
        text: "Aromalar",
        value: "aroma",
      },
    ],
    onFilter: (value, record) => record.category.indexOf(value) === 0,
    render: (text, render) => (
      <p style={{ fontSize: "15px" }}>{render.category} </p>
    ),
  },

  {
    title: "Fiyat",
    dataIndex: "price",
    sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price),

    key: "price",
    render: (text, render) => <p style={{ fontSize: "15px" }}>{text} ₺</p>,
  },
  {
    title: "İndirimli Fiyat",
    key: "discountPrice",
    render: (text, render) => (
      <p style={{ fontSize: "15px" }}>
        {(render.price - (render.price * render.discountRate) / 100).toFixed(2)}
        ₺
      </p>
    ),
  },
  {
    title: "",
    key: "action",
    render: (text, record) => (
      <span>
        <Link to={`/allproducts/product/${record._id}`}>
          <div
            style={{
              width: "100px",
              height: "40px",
              backgroundColor: "#d35400",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "14px" }}>Görüntüle </span>
          </div>
        </Link>
        <Divider type="horizontal" />
        <Link to={`/allproducts/edit/${record._id}`}>
          <div
            style={{
              width: "100px",
              height: "40px",
              backgroundColor: "#2c3e50",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "14px" }}>Düzenle </span>
          </div>
        </Link>
      </span>
    ),
  },
];

function App() {
  const [response, setResponse] = useState([]);
  useEffect(() => {
    Axios.get(baseUrl + "products")
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "50px 0",
        }}
      >
        <Link to="/allproducts/create">
          <div
            style={{
              width: "150px",
              height: "50px",
              backgroundColor: "#27ae60",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "15px" }}>
              Yeni Ürün Oluştur
            </span>
          </div>
        </Link>
      </div>
      <Table key={"allProductsTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
